import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import from your new API structure
import { accountAPI } from "../../helpers/api/accounts";

// Fetch single account
export const getAccount = createAsyncThunk(
  "accounts/getAccount", 
  async (accountId, { rejectWithValue }) => {
    try {
      const response = await accountAPI.getById(accountId);
      return response;
    } catch (error) {
      toast.error("Failed to fetch account details", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to fetch account");
    }
  }
);

// Fetch all accounts
export const getAccounts = createAsyncThunk(
  "accounts/getAccounts", 
  async (_, { rejectWithValue }) => {
    try {
      const response = await accountAPI.getAll();
      return response;
    } catch (error) {
      toast.error("Failed to fetch accounts", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to fetch accounts");
    }
  }
);

// Add new account
export const addNewAccount = createAsyncThunk(
  "accounts/addNewAccount",
  async (accountData, { rejectWithValue }) => {
    try {
      const response = await accountAPI.create(accountData);
      toast.success("Account Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Account Addition Failed", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to add account");
    }
  }
);

// Update account
export const updateAccount = createAsyncThunk(
  "accounts/updateAccount",
  async ({ id, ...accountData }, { rejectWithValue }) => {
    try {
      const response = await accountAPI.update(id, accountData);
      toast.success("Account Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Account Update Failed", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to update account");
    }
  }
);

// Delete account
export const deleteAccount = createAsyncThunk(
  "accounts/deleteAccount",
  async (accountId, { rejectWithValue }) => {
    try {
      await accountAPI.delete(accountId);
      toast.success("Account Deleted Successfully", { autoClose: 3000 });
      return accountId; // Return the ID for reducer to remove from state
    } catch (error) {
      toast.error("Account Deletion Failed", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to delete account");
    }
  }
);

// Get accounts by phase (if you need this feature)
export const getAccountsByPhase = createAsyncThunk(
  "accounts/getAccountsByPhase",
  async (phaseId, { rejectWithValue }) => {
    try {
      const response = await accountAPI.getByPhase(phaseId);
      return response;
    } catch (error) {
      toast.error("Failed to fetch accounts by phase", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to fetch accounts by phase");
    }
  }
);